import { css } from 'lit';

export const styles = css`
  :host { display: block; }

  .error-message {
    display: flex;
    align-items: center;
    padding: 0.75rem;
    margin-bottom: 1rem;
    background: var(--sl-color-danger-50);
    border: 1px solid var(--sl-color-danger-200);
    border-radius: 6px;
    color: var(--sl-color-danger-700);
    font-size: 0.875rem;
  }

  .error-message sl-icon {
    margin-right: 0.5rem;
  }

  .pm-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid var(--sl-color-neutral-200);
  }

  .pm-header h2 {
    margin: 0;
    color: var(--sl-color-neutral-900);
    font-size: 1.5rem;
    font-weight: 600;
  }

  .pm-status-badge {
    display: flex;
    align-items: center;
  }

  .pm-fields {
    margin-bottom: 1rem;
  }

  .tab-navigation { 
    display: flex; 
    background: var(--sl-color-neutral-100); 
    border-bottom: 1px solid var(--sl-color-neutral-200); 
    margin: 0 -1.5rem 1.5rem; 
  }
  
  .tab-button { 
    padding: 1rem 1.5rem; 
    background: none; 
    border: none; 
    cursor: pointer; 
    display: flex; 
    align-items: center; 
    gap: .5rem; 
    color: var(--sl-color-neutral-600); 
    border-bottom: 3px solid transparent; 
    transition: all .2s ease; 
  }
  
  .tab-button.active { 
    color: var(--sl-color-primary-600); 
    border-bottom-color: var(--sl-color-primary-600); 
    background: white; 
  }

  .tab-button:hover:not(.active) {
    color: var(--sl-color-neutral-800);
    background: var(--sl-color-neutral-50);
  }

  .info-description { 
    color: var(--sl-color-neutral-600); 
    margin-bottom: 1.5rem; 
    font-size: .875rem; 
  }

  .field-row { 
    display: flex; 
    align-items: center; 
    gap: 1rem; 
    margin-bottom: 1rem; 
    padding: .75rem; 
    background: var(--sl-color-neutral-50); 
    border-radius: 8px; 
  }
  
  .field-label { 
    min-width: 120px; 
    font-weight: 600; 
    color: var(--sl-color-neutral-700); 
  }
  
  .field-value { 
    flex: 1; 
    display: flex; 
    align-items: center; 
    gap: .5rem; 
  }

  .field-value sl-input,
  .field-value sl-select,
  .field-value sl-textarea {
    flex: 1;
    min-width: 200px;
  }

  .checklist {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .checklist-item {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    padding: 1rem;
    background: var(--sl-color-neutral-50);
    border-radius: 8px;
    border-left: 4px solid var(--sl-color-primary-500);
  }

  .checklist-number {
    width: 32px;
    height: 32px;
    background: var(--sl-color-primary-600);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 0.875rem;
    flex-shrink: 0;
  }

  .checklist-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .checklist-text {
    font-weight: 500;
    color: var(--sl-color-neutral-900);
  }

  .empty-checklist,
  .empty-parts {
    text-align: center;
    padding: 3rem 1rem;
    color: var(--sl-color-neutral-500);
  }

  .empty-checklist sl-icon,
  .empty-parts sl-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
    display: block;
    color: var(--sl-color-neutral-300);
  }

  .parts-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .part-item {
    padding: 1rem;
    background: var(--sl-color-neutral-50);
    border-radius: 8px;
    border-left: 4px solid var(--sl-color-success-500);
  }

  .part-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .part-name {
    font-weight: 600;
    color: var(--sl-color-neutral-900);
  }

  .part-quantity {
    font-size: 0.875rem;
    color: var(--sl-color-neutral-600);
    background: var(--sl-color-neutral-200);
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
  }
  
  /* Shoelace component overrides */
  sl-dialog {
    --width: 900px;
  }

  sl-button {
    min-width: 120px;
  }
`;
